import {
  AngleTool,
  BidirectionalTool,
  CircleROITool,
  CobbAngleTool,
  CrosshairsTool,
  EllipticalROITool,
  LengthTool,
  MagnifyTool,
  PanTool,
  PlanarFreehandROITool,
  ProbeTool,
  RectangleROITool,
  ReferenceLinesTool,
  StackScrollTool,
  WindowLevelTool,
  ZoomTool,
} from "@cornerstonejs/tools";
import React, { useContext, useEffect, useState } from "react";
import StackScroll from "../../../../../components/SVGComponents/Tools/StackScroll";
import Bidirectional from "../../../../../components/SVGComponents/Tools/Bidirectional";
import Ellipse from "../../../../../components/SVGComponents/Tools/Ellipse";
import Length from "../../../../../components/SVGComponents/Tools/Length";
import Pan from "../../../../../components/SVGComponents/Tools/Pan";
import Probe from "../../../../../components/SVGComponents/Tools/Probe";
import Zoom from "../../../../../components/SVGComponents/Zoom";
import Rectangle from "../../../../../components/SVGComponents/Tools/Rectangle";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import Invert from "../../../../../components/SVGComponents/Tools/Invert";
import FlipVertical from "../../../../../components/SVGComponents/Tools/FlipVertical";
import FlipHorizontal from "../../../../../components/SVGComponents/Tools/FlipHorizontal";
import Annotation from "../../../../../components/SVGComponents/Tools/Annotation";
import WindowLevel from "../../../../../components/SVGComponents/Tools/WindowLevel";
import Reset from "../../../../../components/SVGComponents/Tools/Reset";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import WindowLevelToolComponent from "./WindowLevelToolComponent";
import ReferenceLines from "../../../../../components/SVGComponents/Tools/ReferenceLines";
import CINEPause from "../../../../../components/SVGComponents/Tools/CINEPause";
import CINEPlay from "../../../../../components/SVGComponents/Tools/CINEPlay";
import Synchronize from "../../../../../components/SVGComponents/Tools/Synchronize";
import MPR from "../../../../../components/SVGComponents/Tools/MPR";
import Crosshairs from "../../../../../components/SVGComponents/Tools/Crosshairs";
import Exit from "../../../../../components/SVGComponents/Tools/Exit";
import themeContext from "../../../../../context/theme/ThemeContext";
import Angle from "../../../../../components/SVGComponents/Tools/Angle";
import Compare from "../../../../../components/SVGComponents/Tools/Compare";
import Magnify from "../../../../../components/SVGComponents/Tools/Magnify";
import Circle from "../../../../../components/SVGComponents/Tools/Circle";
import Pencil from "../../../../../components/SVGComponents/Tools/Pencil";
import RotateLeft from "../../../../../components/SVGComponents/Tools/RotateLeft";
import RotateRight from "../../../../../components/SVGComponents/Tools/RotateRight";
import CobbAngle from "../../../../../components/SVGComponents/Tools/CobbAngle";

const GetToolSVG = ({ toolName, hovered }) => {
  const {
    activeTool,
    isCineEnabled,
    isSynchronizedEnabled,
    isMPRActive,
    activeMPRTool,
    isMPRCineEnabled,
    isCompareActive,
    isReferenceLinesEnabled, 
    boundingBoxMode,
    isCropEnable
  } = useContext(ViewportContext);

  const { theme } = useContext(themeContext);

  switch (toolName) {
    case "Reset":
      return (
        <Reset
          color={
            hovered ? theme.palette.activeTool : theme.palette.inactiveTool
          }
        />
      );

    case StackScrollTool.toolName:
      return (
        <StackScroll
          color={
            (isMPRActive && activeMPRTool === toolName) ||
            (!isMPRActive && activeTool === toolName) ||
            hovered
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );
    case WindowLevelTool.toolName:
      return (
        <WindowLevel
          color={
            (isMPRActive && activeMPRTool === toolName) || hovered
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );

    case ZoomTool.toolName:
      return (
        <Zoom
          color={
            (isMPRActive && activeMPRTool === toolName) ||
            activeTool === toolName ||
            hovered
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );

    case MagnifyTool.toolName:
      return (
        <Magnify
          color={
            (isMPRActive && activeMPRTool === toolName) ||
            activeTool === toolName ||
            hovered
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );

    case PlanarFreehandROITool.toolName:
      return (
        <Pencil
          color={
            (isMPRActive && activeMPRTool === toolName) ||
            activeTool === toolName ||
            hovered
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );

    case CircleROITool.toolName:
      return (
        <Circle
          color={
            (isMPRActive && activeMPRTool === toolName) ||
            activeTool === toolName ||
            hovered
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );

    case PanTool.toolName:
      return (
        <Pan
          color={
            (isMPRActive && activeMPRTool === toolName) ||
            activeTool === toolName ||
            hovered
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );

    case LengthTool.toolName:
      return (
        <Length
          color={
            (isMPRActive && activeMPRTool === toolName) ||
            activeTool === toolName ||
            hovered
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );

    case BidirectionalTool.toolName:
      return (
        <Bidirectional
          color={
            (isMPRActive && activeMPRTool === toolName) ||
            activeTool === toolName ||
            hovered
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );

    case ProbeTool.toolName:
      return (
        <Probe
          color={
            (isMPRActive && activeMPRTool === toolName) ||
            activeTool === toolName ||
            hovered
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );
    case EllipticalROITool.toolName:
      return (
        <Ellipse
          color={
            (isMPRActive && activeMPRTool === toolName) ||
            activeTool === toolName ||
            hovered
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );

    case RectangleROITool.toolName:
      return (
        <Rectangle
          color={
            ((isMPRActive && activeMPRTool === toolName) ||
            activeTool === toolName ||
            hovered) && !boundingBoxMode && !isCropEnable
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );

    case "Invert":
      return (
        <Invert
          color={
            hovered ? theme.palette.activeTool : theme.palette.inactiveTool
          }
        />
      );

    case "RotateRight":
      return (
        <RotateRight
          color={
            hovered ? theme.palette.activeTool : theme.palette.inactiveTool
          }
        />
      );

      case "RotateLeft":
        return (
          <RotateLeft
            color={
              hovered ? theme.palette.activeTool : theme.palette.inactiveTool
            }
          />
        );
    case "FlipVertical":
      return (
        <FlipVertical
          color={
            hovered ? theme.palette.activeTool : theme.palette.inactiveTool
          }
        />
      );
    case "FlipHorizontal":
      return (
        <FlipHorizontal
          color={
            hovered ? theme.palette.activeTool : theme.palette.inactiveTool
          }
        />
      );
    case "ArrowAnnotate":
      return (
        <Annotation
          color={
            activeTool === toolName || hovered
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );
    case ReferenceLinesTool.toolName:
      return (
        <ReferenceLines
          color={
            (isMPRActive && activeMPRTool === toolName) ||
            (!isMPRActive && isReferenceLinesEnabled) ||
            hovered
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );
    case "CINE":
      return (!isMPRActive && isCineEnabled) ||
        (isMPRActive && isMPRCineEnabled) ? (
        <CINEPause />
      ) : (
        <CINEPlay
          color={
            hovered ? theme.palette.activeTool : theme.palette.inactiveTool
          }
        />
      );

    case "Synchronize":
      return (
        <Synchronize
          color={
            isSynchronizedEnabled || hovered
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );

    case "MPR":
      return (
        <MPR
          color={
            isMPRActive || hovered
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );

    case "Compare":
      return (
        <Compare
          color={
            isCompareActive || hovered
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );
    case CrosshairsTool.toolName:
      return (
        <Crosshairs
          color={
            activeMPRTool === toolName || hovered
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );

    case AngleTool.toolName:
      return (
        <Angle
          color={
            activeMPRTool === toolName || hovered   //change the activeTool to activeMPRTool
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );

    case CobbAngleTool.toolName:
      return (
        <CobbAngle
          color={
            activeMPRTool === toolName || hovered //change the activeTool to activeMPRTool
              ? theme.palette.activeTool
              : theme.palette.inactiveTool
          }
        />
      );
    case "EXITMPR":
      return (
        <Exit
          color={
            hovered ? theme.palette.activeTool : theme.palette.inactiveTool
          }
        />
      );

    default:
      break;
  }
};

export default GetToolSVG;
